import { Tactic } from "../../../redux/tactics/tacticsSlice";
import axios from "../../apiFc24";
import { MetaRating } from "./get-meta-ratings";

type ResponseType = {
  manager: {
    country: number;
    league: number;
  };
  squadName: string;
  tactic: Tactic;
  currentFormation: string;
  players: {
    resourceId: number;
    untradeable: boolean;
    cardName: string;
    clubId: number;
    countryId: number;
    leagueId: number;
    rating: number;
    preferredPosition: string;
    possiblePositions: string[];
    price: number;
    metaRatings: MetaRating[];
    metalId: number;
    versionId: number;
    attributes: number[];
    hasDynamicImage: boolean;
    playerUrl: string;
    chemStyle?: number;
  }[];
};

export const importSquad = async (): Promise<ResponseType> => {
  const res = await axios.get<Promise<ResponseType>>("/user-squads/active");
  return res.data;
};
